import WebpackerReact from "webpacker-react";
import { NotesPanel } from "n2-styles";

export default class StorePromosRecipients {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  index() {
    WebpackerReact.setup({ NotesPanel });
  }
}
